

























import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    tabs: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    active: Number,
    edit: Boolean,
    add: Boolean
  },
  data() {
    return {
      isEditing: false,
      editedValue: '',
      updateTimeout: undefined as number | undefined,
    };
  },
  computed: {
    isEditedValueValid(): boolean {
      const { editedValue, tabs } = this;
      return editedValue !== '' && !tabs.find(tab => tab === editedValue);
    },
    canDelete(): boolean {
      return this.tabs.length > 1;
    },
  },
  methods: {
    selectTab(index: number) {
      if (index === this.active && this.edit) {
        this.startEditTab();
      } else {
        this.$emit('selectTab', index);
      }
    },
    startEditTab() {
      if (this.active === undefined || this.isEditing) {
        return;
      }
      this.isEditing = true;
      this.editedValue = this.tabs[this.active];
      this.$nextTick(
        () => {
          const inp = this.$el.querySelector('input');
          if (inp) {
            inp.focus();
          }
        }
      )
    },
    updateTab() {
      this.updateTimeout = setTimeout(() => {
        if (this.isEditing && this.isEditedValueValid) {
          this.$emit('updateTabName', this.editedValue);
        }
        this.isEditing = false;
        this.editedValue = '';
      }, 150);
    },
    deleteTab() {
      clearTimeout(this.updateTimeout);
      this.isEditing = false;
      this.$emit('deleteTab');
    },
    addTab() {
      this.$emit('addTab');
      this.$nextTick(
        () => {
          this.selectTab(this.tabs.length - 1);
          this.$nextTick(() => {
            this.startEditTab();
          });
        }
      );
    }
  }
});
